import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { SystemService } from '../services/system.service';
import { Version } from '../classes/version';
import { SessionService } from '../services/session.service';
import { UserService } from '../../shared/services/user.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

    public buildVersion: Version;

    constructor(private systemService: SystemService, private sessionService: SessionService, private router: Router, private userService: UserService) { }

    ngOnInit() {
        this.systemService.getVersion().subscribe(data => {
            this.buildVersion = new Version(data.major, data.minor, data.buildNumber, data.gitHash, data.gitBranch);
        });
    }

    userLogout(): void {
        this.sessionService.logout();
        this.userService.userLogout()
            .subscribe(
            data => {
                this.sessionService.destroySessionCookie();
                this.router.navigate(['/']);
            },
            error => {
                this.sessionService.destroySessionCookie();
                this.router.navigate(['/']);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts